import { MsalProvider } from '@azure/msal-react';

import { msalInstance } from './config'

interface AuthProviderProps {
  children: React.ReactNode;
}

export const AuthProvider = (props: AuthProviderProps) => {
  const { children } = props;

  return (
    <MsalProvider instance={msalInstance}>
      {children}
    </MsalProvider>
  )
}